import styled, {keyframes} from 'styled-components';
interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
    overlay?: boolean;
    isOn?:boolean;
};

export const fadeIn = keyframes`
  from {
    transform: translateY(-14px); /* 위에서 내려오는 효과를 줍니다. */
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }
    
  30%{
      opacity: 0;
  }  
    
  to {
    transform: translateY(0); /* 위치를 변화시켜 아래로 이동합니다. */
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;

export const fadeIn5 = keyframes`
  from {
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }
    
  30%{
      opacity: 0;
  }  
    
  to {
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;

export const fadeInT = keyframes`
  from {
    transform: translateY(-8px); /* 위에서 내려오는 효과를 줍니다. */
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }
    
  30%{
      opacity: 0.5;
  }  
    
  to {
    transform: translateY(0); /* 위치를 변화시켜 아래로 이동합니다. */
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;

export const fadeIn2 = keyframes`
  from {
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }
    
  90%{
      opacity: 0;
  }  
    
  to {
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;
export const fadeInPopup = keyframes`
  from {
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
    left: 50%;
      top: 50%;
  }
  
  20%{
      transform: translateY(-40px);
  }  
    
  80%{
      opacity: 0;
  }  
    
  to {
    opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
      transform: none;
  }
`;
export const InputArea = styled.div`
    width: 37%;
    display: flex;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
    align-items: center;
    flex-direction: row;
    border: solid 2px rgba(51, 51, 51, 0);
    box-sizing: content-box;
    transition: all 0.2s;
    position: relative;
    cursor: default;
    .close{
        cursor: pointer;
        position: absolute;
        height: 90%;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        right: 90px;
        background: #fff!important;
        border-radius: 50%;

        svg{
            width: 18px;
            height: 18px;
            path{
                &:nth-last-of-type(1){
                    stroke-width: 1px;
                }
            }
        }
    }
    &.on {
        border: solid 2px #333;
    }
    input {
        &:focus {
            border: none!important;
        }
    }

    div {
        & > div {
            background: #d5d5d5;
        }
        
        &:hover {
            background: #d5d5d5;
        }
        transition: all 0.2s;
        height: 100%;
        box-sizing: border-box;
        padding: 0 8px;
        background: #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
            padding-bottom: 0px;
        }

        span {
            font-weight: 700;
            font-size: 16px;
            margin-left: 8px;
        }
    }

    input {
        padding-left: 15px;
        outline: none;
        display: flex;
        height: 100%;
        width: 100%;
        flex: 1;
        border-radius: 8px 0 0 8px;
        border: solid 1px #e5e5e5;
        border-right: none;

        &::placeholder {
            opacity: 0.5;
        }
    }
`;

export const fadeIn3 = keyframes`
    0% {
        opacity: 0;
        //transform: translateY(-35px) ;
    }
    50% {
        opacity:0%; /* 중간 상태에서 조금 투명하게 */
        //transform: translateY(-17px) ;
    }
    80%{
        opacity: 0.7;
        //transform: translateY(0) ;
    }
    100% {
   
        opacity: 1;
    }
`;

export const fadeInS = keyframes`
    0% {
        opacity: 0;
        transform: translateX(10px) ;
    }
    50% {
        //transform: translateY(-17px) ;
    }
    80%{
        opacity: 0.7;
        //transform: translateY(0) ;
    }
    100% {
        transform: translateX(0px) ;
        opacity: 1;
    }
`;

export const fadeIn4 = keyframes`
    0% {
    }
    50% {
        opacity:0%; /* 중간 상태에서 조금 투명하게 */
        //transform: translateY(-17px) ;
    }
    80%{
        opacity: 0;
        
    }
    100% {
   
        opacity: 1;
    }
`;

export const Title = styled.div`

`;

export const FormBox = styled.dl`
    > dt {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        opacity: 0.8;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
export const FormBoxItemWrap = styled.ul`
    width: 100%;
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;
export const ProfileFormBoxItemWrap = styled.ul`
    width: 100%;
    > li {
        font-size: 16px;
        margin: 8px 0 8px 0;
    }
`;
export const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        &.account{
            flex-direction: row;
        }
    }
`;
export const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
    @media screen and (max-width: 768px) {
        flex-direction: column;
        width: 100%;
    }
`;

export const SucPopup = styled.div`
  z-index: 99999;
  border: 1.6px solid rgba(18, 166, 94, 1);
  background: rgba(226, 255, 241, 0.85);
  width: 520px;
  height: 66px;
  position: absolute;
  left: 50%;
  top: 70px;
  transform: translateX(-50%);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 10px;
  svg{
    width: 20px;
    height: 20px;
  }
  animation: ${fadeIn2} 0.25s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
`
export const FormItem = styled.div`
    position: relative;
    > input,
    select,
    textarea {
        box-sizing: border-box;
        transition: all 0.2s;
        color: #333;
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px #3333334D;
        padding: 12px 16px;
        height: 47px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] input[type="password"] {
        height: 48px;

    }
    .error{
        border: solid 1px #ea4335!important;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
    .editIcon{

        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%) scale(90%);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const AddChapter = styled.div`
    background: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 106px;
    height: 40px;
    justify-content: center;
    border-radius: 5px;

    cursor: pointer;
    span, button {
        color: #fff;
        font-size: 18px;
        margin-right: 10px;
        font-weight: 400;
        background: none;
        border: none;
        cursor: pointer;
    }
    button{
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
`;

export const Radio = styled.div`
    display: flex;
    align-items: center;
`
export const ContentsHeader = styled.div`
    background: #333;
    padding: 13.4px 24px;
    color: #ddc160;
    font-size: 22px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
`;
export const RadioButton = styled.div`
    display: flex;
    align-items: center;
    transition: all 0.3s;

    cursor: pointer;
    .circle{
        transition: all 0.3s;
        width: 20px;
        height: 20px;
        border-radius: 100px;
        border:solid 1px #33333326;
        .on&{
            border:solid 5px #DDC160;
        }
    }
    span{
        margin-left: 10px;
        font-family: Europa-Bold;
        font-size: 20px;
        font-weight: 700;
        line-height: 30px;
        letter-spacing: 0em;
        text-align: left;
    }
`

export const SwitchItems = styled.div`
    display: flex;
    width: 40%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    &:nth-last-of-type(1){
        margin-bottom: 0px;
    }
    span{
        font-family: Europa-Bold;
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333;
    }
`
export const SwitchContainer = styled.div`
    position: relative;
    width: 45px;
    height: 26px;
    display: flex;
    align-items: center;
`;

export const SwitchSlider = styled.div<StyledComponentProps>`
    position: absolute;
    top: 0;
    left: 0;
    width: 26px;
    height: 26px;
    border-radius: 15px;
    transition: 0.3s;
    background: #333;
    transform: translateX(${props => (props.isOn ? '22px' : '0')});
`;

export const SwitchLabel = styled.label<StyledComponentProps>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 45px;
    height: 21px;
    border-radius: 15px;
    cursor: pointer;
    box-shadow: 0px 0px 8px 0px #00000029 inset;

    background-color:${props => (props.isOn ? '#87CEEB' : '#fff')};

`;

export const SwitchInput = styled.input`
    display: none;
`;